import FaqsPageTab from './FaqsPageTab';

export default FaqsPageTab;
